/*!

 =========================================================
 * Vue Paper Dashboard - v2.0.0
 =========================================================

 * Product Page: http://www.creative-tim.com/product/paper-dashboard
 * Copyright 2019 Creative Tim (http://www.creative-tim.com)
 * Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard/blob/master/LICENSE.md)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
import Vue from "vue";
import App from "./App";
import router from "./router/index";
import store from './store'

import PaperDashboard from "./plugins/paperDashboard";
import "vue-notifyjs/themes/default.css";
import VueSweetalert2 from 'vue-sweetalert2';
import VueSimpleAlert from "vue-simple-alert";

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

// const metaManager = createMetaManager();

Vue.use(VueSweetalert2);
Vue.use(PaperDashboard);
Vue.use(VueSimpleAlert);
Vue.use(Toast, {
	toastClassName: "my-custom-toast-class",
	bodyClassName: ["custom-class-1"],
	closeButtonClassName: "custom-close-btn",
	transition: "Vue-Toastification__fade",
	transitionDuration: 700,
	maxToasts: 1,
	newestOnTop: true,
	position: "top-right",
	timeout: 2540,
	closeOnClick: true,
	pauseOnFocusLoss: true,
	pauseOnHover: true,
	draggable: true,
	draggablePercent: 0.6,
	showCloseButtonOnHover: false,
	hideProgressBar: true,
	closeButton: "button",
	icon: false,
	rtl: false,
});

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
